import React, { useRef, useEffect } from 'react';
import Slider from "react-slick";


export default function ImagesSlider({ images }) {
	const sliderRef = useRef(null);

	useEffect(() => {
		const slider = sliderRef.current;

		const preventTouchEvents = (e) => {
			e.stopPropagation(); // Prevent the event from reaching the parent
		};

		if (slider) {
			// Attach event listeners to prevent touch events from propagating to parent
			slider.addEventListener('touchstart', preventTouchEvents);
			slider.addEventListener('touchmove', preventTouchEvents);
			slider.addEventListener('touchend', preventTouchEvents);
		}

		return () => {
			if (slider) {
				// Clean up the event listeners when the component is unmounted
				slider.removeEventListener('touchstart', preventTouchEvents);
				slider.removeEventListener('touchmove', preventTouchEvents);
				slider.removeEventListener('touchend', preventTouchEvents);
			}
		};
	}, []);

	const settings = {
		dots: false,
		infinite: (images.length > 1),
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		arrows: false,
	};

	return (
		<div className='WelcomeSlider' ref={sliderRef}>
			<Slider {...settings}>
				{
					images.map((item, i) => {
						return (
							<div key={i}>
								<img src={item} alt="Slide" />
							</div>
							
						)
					})
				}
				
			</Slider>
		</div>
	);
}


